import {
	Component,
	Input,
	Output,
	EventEmitter,
	ChangeDetectionStrategy
} from '@angular/core';
import {PageConfig, ACTION_IDS} from '../../models/data-table.models';
import {Action, ActionSet} from 'src/app/models/layout';
import {ContactGroupDialogComponent} from "../../../contact-group-dialog/contact-group-dialog.component";
import {DialogComponent} from "libComm";
import {AuthService} from "../../../../../services/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {TableControllerService} from "../../../../../services/table-controller.service";

/**
 * Renders the toolbar above the data table.
 * Contains action buttons, pagination, and settings.
 */
@Component({
	selector: 'data-table-toolbar',
	templateUrl: './data-table-toolbar.component.html',
	styleUrls: ['./data-table-toolbar.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataTableToolbarComponent
{
	@Input() actionset: ActionSet | null = null;
	@Input() disabledActions: Action[] = [];
	@Input() length = 0;
	@Input() numElementsLoaded = 0;
	@Input() pageEvent: PageConfig = {pageIndex: 0, previousPageIndex: 0, loader: 50, size: 50};
	@Input() showColumnSettings = false;

	// Pre-computed action availability
	@Input() showMultiselectDropdown = false;
	@Input() showMultiselectDropdownMenu = false;

	//ITOEM-05: added logic to display notification option button
	@Input()
	notificationOption: any[];

	//ITOEM-05: added logic to display notification option button
	@Input()
	manualOption: any[];

	@Input() tableController!: TableControllerService;
	@Input() detailId: string = '';

	@Output() actionEmit = new EventEmitter<string>();
	@Output() addClick = new EventEmitter<void>();
	@Output() clearSort = new EventEmitter<void>();
	@Output() resetSort = new EventEmitter<void>();
	@Output() pageChange = new EventEmitter<any>();
	@Output() openSettings = new EventEmitter<MouseEvent>();

	readonly ACTION_IDS = ACTION_IDS;

	constructor(
		public dialog: MatDialog
	)
	{
	}

	isActionDisabled(actionId: string): boolean
	{
		return this.disabledActions.some(act => act.id === actionId);
	}

	onActionEmit(actionId: string): void
	{
		this.actionEmit.emit(actionId);
	}

	onAddClick(): void
	{
		this.addClick.emit();
	}

	onClearSort(): void
	{
		this.clearSort.emit();
	}

	onResetSort(): void
	{
		this.resetSort.emit();
	}

	onPageChange(event: any): void
	{
		this.pageChange.emit(event);
	}

	onOpenSettings(event: MouseEvent): void
	{
		this.openSettings.emit(event);
	}

	trackByActionId(index: number, action: Action): string
	{
		return action.id;
	}

	// ITOEM-05: added logic to hande notification
	notifyRecords(option: any)
	{
		const id = option.notificationId;
		const action = option.notificationTypology;
		const label = option.notificationLabel;
		const description = option.notificationDescription;
		const mySelection: any[] = this.tableController.selection.selected;
		const ids: any[] = mySelection.map((row) => row["ID"]);
		if (ids == null || ids.length == 0)
		{
			this.dialog.open(DialogComponent, {
				data: {
					title: "No row selected",
					content: `Please select at least 1 row...`,
					confirmButtonLabel: "Ok",
					confirmButtonColor: "basic"
				}
			});
		}
		else
			if (!!id)
			{
				this.dialog.open(ContactGroupDialogComponent, {
					width: '65vw',
					data: {
						title: label + ' - ' + description,
						ids: ids,
						typology: action,
						notificationId: id,
						closeButtonLabel: "ACT_CLOSE",
						confirmButtonLabel: "ACT_SEND"
					}
				});
			}
	}

}
